import { MESSAGES, SURVEY } from "../constants/app";

/** Returns a validation error message for patient mobile, or null if valid. */
export function getPatientMobileValidationError(
  phone: string | undefined
): string | null {
  const trimmed = phone?.trim() ?? "";
  if (!trimmed) {
    return MESSAGES.VALIDATION.REQUIRED_FIELD;
  }
  if (!SURVEY.VALIDATION.MOBILE_REGEX.test(trimmed)) {
    return MESSAGES.VALIDATION.INVALID_MOBILE;
  }
  return null;
}
